var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubble2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 321.13,
    height: 246.416,
    viewBox: "0 0 321.13 246.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(-536.274 -423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    transform: "translate(569.405 423)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 202,
    rx: 65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 285,
    height: 199,
    rx: 63.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(530.84 643.851) rotate(-60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_7",
    "data-name": "Polygon 7",
    transform: "matrix(0.208, -0.978, 0.978, 0.208, 0, 51.131)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 50.02687454223633 61.5 L 2.246264457702637 61.5 L 26.13656997680664 3.914431095123291 L 50.02687454223633 61.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.13656997680664 7.828853607177734 L 4.492527008056641 60 L 47.78061294555664 60 L 26.13656997680664 7.828853607177734 M 26.13656997680664 0 L 52.27313613891602 63 L 3.814697265625e-06 63 L 26.13656997680664 0 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M27.509,0,55.018,64.446H0Z",
    transform: "matrix(0.208, -0.978, 0.978, 0.208, 7.953, 53.97)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble2);
export default __webpack_public_path__ + "static/media/chat-bubble2.d4a51b4d11f6d7dee0b66c410135758e.svg";
export { ForwardRef as ReactComponent };